module.exports = __webpack_public_path__ + "static/media/Illustration.4645688a.png";